import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-32 md:pt-40 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-xl mx-auto text-center">
            <div className="w-20 h-20 rounded-2xl bg-background-100 border border-background-200/70 flex items-center justify-center mx-auto mb-6">
              <i className="ri-error-warning-line text-4xl text-foreground-400" />
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              {t("pageNotFound")}
            </h1>
            <p className="text-foreground-600 mb-8 leading-relaxed">
              {t("pageNotFoundDesc")}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/"
                className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                {t("backToHome")}
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-lg border-2 border-primary-500 text-primary-700 font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {t("ctaVisitMain")}
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}